import React from "react";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { PLAN_UPGRADE_URL } from "./planCapabilities";
import {
  isFeatureNotIncluded,
  SCHEDULING_NOT_INCLUDED_MESSAGE,
} from "./planErrors";

/**
 * Aviso ÚNICO de "sua capacidade não está no plano" (ADR-0026).
 *
 * Existe porque o 403 `FEATURE_NOT_INCLUDED` é alcançável em TODA tela de
 * agenda durante a janela fail-safe — entre o deploy do frontend e o do
 * backend, `GET /auth/me` ainda não expõe `schedulingIncluded`, o gate de UI
 * libera tudo (de propósito) e a mutação morre no backend. É a janela MAIS
 * provável, não a menos. Sem isto, o usuário vê o texto cru do backend.
 *
 * `toast.info` (não `error`): não é falha do usuário, é um convite.
 */
export function SchedulingUpgradeToast({ message }) {
  return (
    <span>
      {message}{" "}
      <Link
        to={PLAN_UPGRADE_URL}
        style={{ fontWeight: 700, textDecoration: "underline" }}
      >
        Ver planos
      </Link>
    </span>
  );
}

/**
 * Dispara o aviso. Deduplicado por `toastId`: um clique que dispara duas
 * mutações gateadas não empilha dois convites idênticos.
 */
export function notifySchedulingNotIncluded(
  message = SCHEDULING_NOT_INCLUDED_MESSAGE,
) {
  toast.info(<SchedulingUpgradeToast message={message} />, {
    toastId: "scheduling-not-included",
    autoClose: 8000,
  });
}

/**
 * GUARD CANÔNICO para o catch de qualquer mutação em rota gateada por
 * `requireScheduling`. Uso:
 *
 *   } catch (err) {
 *     if (handleFeatureNotIncluded(err)) return;   // ← única linha nova
 *     ...tratamento existente, intacto...
 *   }
 *
 * Retorna `true` SOMENTE para 403 + `code: "FEATURE_NOT_INCLUDED"`. Qualquer
 * outro erro devolve `false` e segue para o tratamento de sempre da tela —
 * inclusive o 403 de `LIMIT_REACHED`, que é o OUTRO eixo (volume, não tier) e
 * não pode virar a mesma mensagem.
 *
 * @param {unknown} err erro capturado
 * @param {string} [message] copy específica da tela, se a genérica não servir
 * @returns {boolean} true se o erro foi tratado aqui
 */
export function handleFeatureNotIncluded(err, message) {
  if (!isFeatureNotIncluded(err)) return false;
  notifySchedulingNotIncluded(message);
  return true;
}
